
import Vue from 'vue';
import { ClientConstants } from '../client.constants';
import { Utils } from '../utils/Utils';

export default Vue.extend({
    name: 'Taxes',

    props: {
        title: String,
        federalInputLabel: String,
        stateInputLabel: String,
        localIncomeInputLabel: String,
        selectedFederalValue: String,
        selectedStateValue: String,
        localIncomeTaxInput: Number,
        federalOptions: Array,
        stateOptions: Array,
        federalFilingStatusError: String,
        stateResidenceError: String,
        localIncomeTaxError: String,
        federalIsInvalid: Boolean,
        stateIsInvalid: Boolean,
    },

    data: function () {
        return {
            localTaxIsInvalid: false,
            localTaxNativeAttributes:
                '{"inputmode": "decimal", "pattern": "^(?=.)(?:(?:(?:0?[0-9]|1[0-4])?(?:[.][0-9]{1,2})?)|15(?:[.]00?)?)$"}',
            filingStatusNativeAttributes:
                '{"data-cy" : "filing-status-select"}',
            stateSelectNativeAttributes: '{"data-cy" : "state-select"}',
            clientConstants: ClientConstants,
        };
    },

    methods: {
        handleInput: function (e: any) {
            // check to ensure only one decimal
            Utils.handleInputDecimal(e);
            // check for a numeric key or a decimal or a cmd/ctrl key
            Utils.handleNumberInput(e);
        },
        onPaste: function (e: any) {
            // check if the copied paste is valid
            Utils.handlePasteValid(e);
        },
        handleFederalChange: function (e: any) {
            let val = e.target.value;
            this.$emit('handleFederalChange', val);
        },
        handleStateChange: function (e: any) {
            let val = e.target.value;
            this.$emit('handleStateChange', val);
        },
        handleLocalTaxChange: function (e: any) {
            this.localTaxIsInvalid = false;
            let val =
                e.target.value.trim() === ''
                    ? 0
                    : parseFloat(parseFloat(e.target.value).toFixed(2));
            this.$emit('handleLocalTaxChange', Number(val));
        },
        handelLocalTaxInvalid() {
            this.localTaxIsInvalid = true;
        },
    },
});
